module.exports = __webpack_public_path__ + "static/media/dlc_check.9c854d35.svg";